import axios from 'axios';

// const URL = 'http://localhost:4000'
const URL = process.env.REACT_APP_BASE_URL || 'https://roshi-chat.herokuapp.com' 

axios.defaults.baseURL = URL;

export const GetPost = async (userID) => {
    let res = await axios.get('/coach/posts/all', {
        params: {
            userId: userID
        }
    })
    return res.data
}
export const AddPost = async (data) => {
    let res = await axios.post('/coach/post/add', data)
    return res.data
}
export const DeletePost = async (id) => {
    return axios.delete(`/coach/post/${id}`)
    // return res.data
}

export const UpdatePost = async (data, id) => {
    let res = await axios.put(`/coach/post/${id}`, data)
    return res.data
}